(function () {
  'use strict';

  const items = document.querySelectorAll('.results-stats__item');
  if (!items.length) return;

  const DURATION = 2000;

  function animateItem(item) {
    const bar = item.querySelector('.results-stats__bar-fill');
    const counter = item.querySelector('.results-stats__percent-value');
    const target = parseFloat((bar && bar.dataset.percent) || (counter && counter.dataset.percent)) || 0;

    if (bar) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.transition = 'width ' + DURATION + 'ms ease';
          bar.style.width = target + '%';
        });
      });
    }

    if (counter) {
      let start = null;

      function step(timestamp) {
        if (start === null) start = timestamp;
        const progress = Math.min((timestamp - start) / DURATION, 1);
        counter.textContent = Math.round(progress * target);
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }
  }

  // ── IntersectionObserver — animates once on first entering the viewport ──
  const observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateItem(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.4
  });

  items.forEach(function (item) {
    observer.observe(item);
  });
})();
